import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzModalService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {LoginUserComponent} from "../components/login-user/login-user.component";

@Injectable()
export class LoginFilter implements CanActivate{

  constructor(private router: Router,
              private showConfirm: NzModalService,){}

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    //判断session中是否存在userId
    if(sessionStorage.getItem('userId') !== null) {
      return true;
    }
    let url = state.url;//拦截前url
    //判断当前url是通过路由跳转还是通过地址栏输入
    //console.log(document.referrer);
    if(document.referrer !== '' && document.referrer != null) {
      this.openLogin(url,null);
    }else{
      this.router.navigate(['/comLR/login'],{queryParams: {url: url} })
    }

    return false;
  }

  //打开登录弹窗
  openLogin(url: any, params: any) {
    this.showConfirm.open({
      content: LoginUserComponent,
      componentParams: {
        prevUrl: url,
        prevParams: params,
      },
      width: 360,
      footer: false
    });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/routing/LoginFilter.ts